export default __webpack_public_path__ + "static/media/profile_round.50a3250b.png";